import { fg } from '@atlaskit/platform-feature-flags/fg';

export default {
	get(): boolean {
		return fg('assets_rovo_search_all');
	},
};
